const color = "#111827";

export const logsetting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"logsetting"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];

export const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={"toggler"}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

export const setting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"setting"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#fff"
    ></path>
  </svg>,
];

export const home = [
  <svg
    width="22"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"home"}
  >
    <path
      d="M12.459 0.660591C12.3259 0.556836 12.162 0.500488 11.9932 0.500488C11.8245 0.500488 11.6606 0.556836 11.5275 0.660591L0.75 9.06434L1.68225 10.2433L3 9.21584V18.5001C3.00079 18.8977 3.15908 19.2787 3.44022 19.5599C3.72135 19.841 4.10242 19.9993 4.5 20.0001H19.5C19.8976 19.9993 20.2787 19.841 20.5598 19.5599C20.8409 19.2787 20.9992 18.8977 21 18.5001V9.22259L22.3177 10.2501L23.25 9.07109L12.459 0.660591ZM13.5 18.5001H10.5V12.5001H13.5V18.5001ZM15 18.5001V12.5001C14.9996 12.1024 14.8414 11.7211 14.5602 11.4399C14.279 11.1587 13.8977 11.0005 13.5 11.0001H10.5C10.1023 11.0005 9.721 11.1587 9.43978 11.4399C9.15856 11.7211 9.0004 12.1024 9 12.5001V18.5001H4.5V8.04659L12 2.20409L19.5 8.05409V18.5001H15Z"
      fill="#4D4D4D"
    />
  </svg>,
];

export const order = [
  <svg
    width="22"
    height="24"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"order"}
  >
    <path
      d="M12.4209 0.714355L5.06488 8.07038H0.857422V13.0262H1.88988L4.18688 20.6919L4.36776 21.2858H20.474L20.6549 20.6919L22.9519 13.0262H23.9844V8.07038H19.7769L12.4209 0.714355ZM12.4209 3.06339L17.4287 8.07038H7.41391L12.4209 3.06339ZM2.50935 9.72231H22.3325V11.3742H21.713L21.5321 11.9681L19.2351 19.6339H5.60671L3.30971 11.9681L3.12882 11.3742H2.50935V9.72231ZM8.29109 12.2002V17.9819H9.94301V12.2002H8.29109ZM11.5949 12.2002V17.9819H13.2469V12.2002H11.5949ZM14.8988 12.2002V17.9819H16.5507V12.2002H14.8988Z"
      fill="#4D4D4D"
    />
  </svg>,
];

export const manageProduct = [
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"manageProduct"}
  >
    <path
      d="M19.9263 8.29429H4.64775V18.9892H19.9263V8.29429ZM2.35598 6.76643H22.218V2.18288H2.35598V6.76643ZM21.4541 8.29429V19.7532C21.4541 19.9558 21.3736 20.1501 21.2304 20.2933C21.0871 20.4366 20.8928 20.5171 20.6902 20.5171H3.88383C3.68122 20.5171 3.48691 20.4366 3.34365 20.2933C3.20039 20.1501 3.1199 19.9558 3.1199 19.7532V8.29429H1.59205C1.38945 8.29429 1.19514 8.2138 1.05187 8.07054C0.90861 7.92727 0.828125 7.73297 0.828125 7.53036V1.41895C0.828125 1.21635 0.90861 1.02204 1.05187 0.878778C1.19514 0.735514 1.38945 0.655029 1.59205 0.655029H22.982C23.1846 0.655029 23.3789 0.735514 23.5221 0.878778C23.6654 1.02204 23.7459 1.21635 23.7459 1.41895V7.53036C23.7459 7.73297 23.6654 7.92727 23.5221 8.07054C23.3789 8.2138 23.1846 8.29429 22.982 8.29429H21.4541ZM9.99523 11.35H14.5788C14.7814 11.35 14.9757 11.4305 15.119 11.5737C15.2622 11.717 15.3427 11.9113 15.3427 12.1139C15.3427 12.3165 15.2622 12.5108 15.119 12.6541C14.9757 12.7974 14.7814 12.8778 14.5788 12.8778H9.99523C9.79263 12.8778 9.59832 12.7974 9.45506 12.6541C9.31179 12.5108 9.23131 12.3165 9.23131 12.1139C9.23131 11.9113 9.31179 11.717 9.45506 11.5737C9.59832 11.4305 9.79263 11.35 9.99523 11.35Z"
      fill="#4D4D4D"
    />
  </svg>,
];

export const manageAgent = [
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"manageAgent"}
  >
    <path
      d="M22.5 18C22.5 18 24 18 24 16.5C24 15 22.5 10.5 16.5 10.5C10.5 10.5 9 15 9 16.5C9 18 10.5 18 10.5 18H22.5ZM10.533 16.5C10.5219 16.4985 10.5109 16.4965 10.5 16.494C10.5015 16.098 10.7505 14.949 11.64 13.914C12.468 12.9435 13.923 12 16.5 12C19.0755 12 20.5305 12.945 21.36 13.914C22.2495 14.949 22.497 16.0995 22.5 16.494L22.488 16.497C22.481 16.4982 22.474 16.4992 22.467 16.5H10.533ZM16.5 7.5C17.2956 7.5 18.0587 7.18393 18.6213 6.62132C19.1839 6.05871 19.5 5.29565 19.5 4.5C19.5 3.70435 19.1839 2.94129 18.6213 2.37868C18.0587 1.81607 17.2956 1.5 16.5 1.5C15.7044 1.5 14.9413 1.81607 14.3787 2.37868C13.8161 2.94129 13.5 3.70435 13.5 4.5C13.5 5.29565 13.8161 6.05871 14.3787 6.62132C14.9413 7.18393 15.7044 7.5 16.5 7.5ZM21 4.5C21 5.09095 20.8836 5.67611 20.6575 6.22208C20.4313 6.76804 20.0998 7.26412 19.682 7.68198C19.2641 8.09984 18.768 8.43131 18.2221 8.65746C17.6761 8.8836 17.0909 9 16.5 9C15.9091 9 15.3239 8.8836 14.7779 8.65746C14.232 8.43131 13.7359 8.09984 13.318 7.68198C12.9002 7.26412 12.5687 6.76804 12.3425 6.22208C12.1164 5.67611 12 5.09095 12 4.5C12 3.30653 12.4741 2.16193 13.318 1.31802C14.1619 0.474106 15.3065 0 16.5 0C17.6935 0 18.8381 0.474106 19.682 1.31802C20.5259 2.16193 21 3.30653 21 4.5ZM10.404 10.92C9.80397 10.7311 9.18545 10.6069 8.559 10.5495C8.207 10.516 7.85359 10.4995 7.5 10.5C1.5 10.5 0 15 0 16.5C0 17.5005 0.4995 18 1.5 18H7.824C7.60163 17.5317 7.49074 17.0183 7.5 16.5C7.5 14.985 8.0655 13.437 9.135 12.144C9.4995 11.703 9.924 11.2905 10.404 10.92ZM7.38 12C6.49223 13.3339 6.01266 14.8977 6 16.5H1.5C1.5 16.11 1.746 14.955 2.64 13.914C3.4575 12.96 4.878 12.03 7.38 12.0015V12ZM2.25 5.25C2.25 4.05653 2.72411 2.91193 3.56802 2.06802C4.41193 1.22411 5.55653 0.75 6.75 0.75C7.94347 0.75 9.08807 1.22411 9.93198 2.06802C10.7759 2.91193 11.25 4.05653 11.25 5.25C11.25 6.44347 10.7759 7.58807 9.93198 8.43198C9.08807 9.27589 7.94347 9.75 6.75 9.75C5.55653 9.75 4.41193 9.27589 3.56802 8.43198C2.72411 7.58807 2.25 6.44347 2.25 5.25ZM6.75 2.25C5.95435 2.25 5.19129 2.56607 4.62868 3.12868C4.06607 3.69129 3.75 4.45435 3.75 5.25C3.75 6.04565 4.06607 6.80871 4.62868 7.37132C5.19129 7.93393 5.95435 8.25 6.75 8.25C7.54565 8.25 8.30871 7.93393 8.87132 7.37132C9.43393 6.80871 9.75 6.04565 9.75 5.25C9.75 4.45435 9.43393 3.69129 8.87132 3.12868C8.30871 2.56607 7.54565 2.25 6.75 2.25Z"
      fill="#4D4D4D"
    />
  </svg>,
];

export const campaign = [
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"campaign"}
  >
    <path
      d="M19.2 8.4V10.8H24V8.4H19.2ZM16.8 16.332C17.952 17.184 19.452 18.312 20.64 19.2C21.12 18.564 21.6 17.916 22.08 17.28C20.892 16.392 19.392 15.264 18.24 14.4C17.76 15.048 17.28 15.696 16.8 16.332ZM22.08 1.92C21.6 1.284 21.12 0.636 20.64 0C19.452 0.888 17.952 2.016 16.8 2.88C17.28 3.516 17.76 4.164 18.24 4.8C19.392 3.936 20.892 2.82 22.08 1.92ZM2.4 6C1.08 6 0 7.08 0 8.4V10.8C0 12.12 1.08 13.2 2.4 13.2H3.6V18H6V13.2H7.2L13.2 16.8V2.4L7.2 6H2.4ZM8.436 8.052L10.8 6.636V12.564L8.436 11.148L7.86 10.8H2.4V8.4H7.86L8.436 8.052ZM16.2 9.6C16.2 8.004 15.504 6.564 14.4 5.58V13.608C15.504 12.636 16.2 11.196 16.2 9.6Z"
      fill="#4D4D4D"
    />
  </svg>,
];

export const bell = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"bell"}
  >
    <path
      d="M10 2C6.68632 2 4.00003 4.68629 4.00003 8V11.5858L3.29292 12.2929C3.00692 12.5789 2.92137 13.009 3.07615 13.3827C3.23093 13.7564 3.59557 14 4.00003 14H16C16.4045 14 16.7691 13.7564 16.9239 13.3827C17.0787 13.009 16.9931 12.5789 16.7071 12.2929L16 11.5858V8C16 4.68629 13.3137 2 10 2Z"
      fill="#111827"
    ></path>
    <path
      d="M10 18C8.34315 18 7 16.6569 7 15H13C13 16.6569 11.6569 18 10 18Z"
      fill="#111827"
    ></path>
  </svg>,
];

export const dashboard = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    key={"dashboard"}
  >
    <path
      d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
      fill={"#000"}
    ></path>
    <path
      d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
      fill={"#000"}
    ></path>
    <path
      d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
      fill={"#000"}
    ></path>
  </svg>,
];

export const tables = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"tables"}
  >
    <path
      d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
      fill={color}
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
      fill={color}
    ></path>
  </svg>,
];

export const billing = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"billing"}
  >
    <path
      d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
      fill={color}
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
      fill={color}
    ></path>
  </svg>,
];

export const signin = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"signin"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
      fill={color}
    ></path>
  </svg>,
];

export const signup = [
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    key={"signup"}
  >
    <path
      d="M0,2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8Z"
      transform="translate(4 4)"
      fill={color}
    />
    <path
      d="M2,0A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2V4A2,2,0,0,1,4,2h6A2,2,0,0,0,8,0Z"
      fill={color}
    />
  </svg>,
];

export const heart = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"heart"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
      fill="#fff"
    ></path>
  </svg>,
];
export const cart = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"cart"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z"
      fill="#fff"
    ></path>
  </svg>,
];

export const goBack = [
  <svg
    width="10"
    height="16"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"goBack"}
  >
    <path
      d="M11.0109 18.9345L2.78941 10.5003L11.0109 2.0662C11.1581 1.91551 11.2405 1.71322 11.2405 1.50258C11.2405 1.29193 11.1581 1.08964 11.0109 0.938952C10.9394 0.865988 10.8541 0.808023 10.7599 0.768451C10.6657 0.728879 10.5646 0.708496 10.4625 0.708496C10.3603 0.708496 10.2592 0.728879 10.165 0.768451C10.0709 0.808023 9.98553 0.865988 9.91404 0.938952L1.16604 9.91139C1.01245 10.069 0.926493 10.2803 0.926493 10.5003C0.926493 10.7204 1.01245 10.9317 1.16604 11.0893L9.91235 20.0617C9.98389 20.1352 10.0694 20.1936 10.1639 20.2335C10.2584 20.2733 10.3599 20.2939 10.4625 20.2939C10.565 20.2939 10.6665 20.2733 10.761 20.2335C10.8555 20.1936 10.9411 20.1352 11.0126 20.0617C11.1598 19.911 11.2422 19.7087 11.2422 19.4981C11.2422 19.2874 11.1598 19.0851 11.0126 18.9345L11.0109 18.9345Z"
      fill="black"
    />
  </svg>,
];

export const search = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"search"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3257 12.8987L19.7057 18.2787C19.8948 18.468 20.001 18.7246 20.0009 18.9921C20.0008 19.2596 19.8945 19.5161 19.7052 19.7052C19.516 19.8943 19.2594 20.0005 18.9919 20.0004C18.7244 20.0003 18.4678 19.894 18.2787 19.7047L12.8987 14.3247C11.2905 15.5704 9.26802 16.1566 7.24287 15.9641C5.21772 15.7716 3.34198 14.8148 1.99723 13.2884C0.652477 11.7619 -0.0602651 9.78056 0.00399633 7.74729C0.0682577 5.71402 0.904695 3.7816 2.34315 2.34315C3.7816 0.904695 5.71402 0.0682577 7.74729 0.00399633C9.78056 -0.0602651 11.7619 0.652477 13.2884 1.99723C14.8148 3.34198 15.7716 5.21772 15.9641 7.24287C16.1566 9.26802 15.5704 11.2905 14.3247 12.8987H14.3257ZM8.00074 13.9997C9.59204 13.9997 11.1182 13.3676 12.2434 12.2424C13.3686 11.1172 14.0007 9.59104 14.0007 7.99974C14.0007 6.40845 13.3686 4.88232 12.2434 3.7571C11.1182 2.63189 9.59204 1.99974 8.00074 1.99974C6.40944 1.99974 4.88332 2.63189 3.7581 3.7571C2.63289 4.88232 2.00074 6.40845 2.00074 7.99974C2.00074 9.59104 2.63289 11.1172 3.7581 12.2424C4.88332 13.3676 6.40944 13.9997 8.00074 13.9997Z"
      fill="black"
    />
  </svg>,
];

export const chat = [
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"chat"}
  >
    <path
      d="M7.47127 11.1451C7.47127 11.5414 7.31382 11.9215 7.03356 12.2018C6.7533 12.482 6.37319 12.6395 5.97684 12.6395C5.5805 12.6395 5.20039 12.482 4.92013 12.2018C4.63987 11.9215 4.48242 11.5414 4.48242 11.1451C4.48242 10.7487 4.63987 10.3686 4.92013 10.0883C5.20039 9.80808 5.5805 9.65063 5.97684 9.65063C6.37319 9.65063 6.7533 9.80808 7.03356 10.0883C7.31382 10.3686 7.47127 10.7487 7.47127 11.1451ZM13.449 11.1451C13.449 11.5414 13.2915 11.9215 13.0112 12.2018C12.731 12.482 12.3509 12.6395 11.9545 12.6395C11.5582 12.6395 11.1781 12.482 10.8978 12.2018C10.6176 11.9215 10.4601 11.5414 10.4601 11.1451C10.4601 10.7487 10.6176 10.3686 10.8978 10.0883C11.1781 9.80808 11.5582 9.65063 11.9545 9.65063C12.3509 9.65063 12.731 9.80808 13.0112 10.0883C13.2915 10.3686 13.449 10.7487 13.449 11.1451ZM17.9322 12.6395C18.3286 12.6395 18.7087 12.482 18.9889 12.2018C19.2692 11.9215 19.4266 11.5414 19.4266 11.1451C19.4266 10.7487 19.2692 10.3686 18.9889 10.0883C18.7087 9.80808 18.3286 9.65063 17.9322 9.65063C17.5359 9.65063 17.1558 9.80808 16.8755 10.0883C16.5952 10.3686 16.4378 10.7487 16.4378 11.1451C16.4378 11.5414 16.5952 11.9215 16.8755 12.2018C17.1558 12.482 17.5359 12.6395 17.9322 12.6395Z"
      fill="black"
    />
    <path
      d="M3.23542 22.8072L3.26531 22.8013C6.00011 22.2588 7.67087 21.543 8.44797 21.1499C9.59208 21.4551 10.7713 21.6088 11.9554 21.6072C18.5577 21.6072 23.9108 16.9237 23.9108 11.1463C23.9108 5.36882 18.5577 0.685303 11.9554 0.685303C5.35302 0.685303 0 5.36882 0 11.1463C0 13.7764 1.11036 16.1825 2.94401 18.0206C2.81573 19.2013 2.553 20.3636 2.16093 21.4847L2.15645 21.5011C2.04503 21.8222 1.92342 22.1397 1.79181 22.4531C1.67375 22.731 1.9024 23.0419 2.19979 22.994C2.54599 22.9374 2.89125 22.8751 3.23542 22.8072ZM4.43096 18.1626C4.4519 17.9438 4.42431 17.7231 4.35018 17.5162C4.27604 17.3093 4.15718 17.1212 4.00206 16.9655C2.41798 15.3755 1.49442 13.3401 1.49442 11.1463C1.49442 6.37606 5.98367 2.17973 11.9554 2.17973C17.9271 2.17973 22.4163 6.37606 22.4163 11.1463C22.4163 15.9179 17.9271 20.1128 11.9554 20.1128C10.902 20.1143 9.85289 19.9777 8.83503 19.7063C8.47932 19.611 8.10095 19.6504 7.77249 19.8169C7.19415 20.1098 5.91941 20.6687 3.83618 21.1514C4.12681 20.1758 4.32593 19.1752 4.43096 18.1626Z"
      fill="black"
    />
  </svg>,
];

export const rightMini = [
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key="rightMini"
  >
    <path
      d="M3.81059 5.00081L0.943359 2.17281L2.37647 0.757812L6.67681 5.00081L2.37647 9.24381L0.943359 7.82881L3.81059 5.00081Z"
      fill="black"
    />
  </svg>,
];

export const cancelOut = [
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"cancelOut"}
  >
    <path
      d="M12 2.5C6.47 2.5 2 6.97 2 12.5C2 18.03 6.47 22.5 12 22.5C17.53 22.5 22 18.03 22 12.5C22 6.97 17.53 2.5 12 2.5ZM12 20.5C7.59 20.5 4 16.91 4 12.5C4 8.09 7.59 4.5 12 4.5C16.41 4.5 20 8.09 20 12.5C20 16.91 16.41 20.5 12 20.5ZM15.59 7.5L12 11.09L8.41 7.5L7 8.91L10.59 12.5L7 16.09L8.41 17.5L12 13.91L15.59 17.5L17 16.09L13.41 12.5L17 8.91L15.59 7.5Z"
      fill="#FF0000"
    />
  </svg>,
];

export const money = [
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"money"}
  >
    <path
      d="M25.938 0.75L1.155 5H13L24.313 3.062L24.655 5H26.687L25.937 0.75H25.938ZM0 6V22H28V6H0ZM4.938 8H23.063C23.0247 8.16403 23.0036 8.3316 23 8.5C23 9.16304 23.2634 9.79893 23.7322 10.2678C24.2011 10.7366 24.837 11 25.5 11C25.673 11 25.837 10.97 26 10.937V17.063C25.836 17.0247 25.6684 17.0036 25.5 17C24.837 17 24.2011 17.2634 23.7322 17.7322C23.2634 18.2011 23 18.837 23 19.5C23 19.673 23.03 19.837 23.063 20H4.938C4.971 19.837 5 19.673 5 19.5C5 19.1717 4.93534 18.8466 4.8097 18.5433C4.68406 18.24 4.49991 17.9644 4.26777 17.7322C4.03562 17.5001 3.76002 17.3159 3.45671 17.1903C3.15339 17.0647 2.8283 17 2.5 17C2.327 17 2.163 17.03 2 17.063V10.938C2.163 10.971 2.327 11 2.5 11C2.8283 11 3.15339 10.9353 3.45671 10.8097C3.76002 10.6841 4.03562 10.4999 4.26777 10.2678C4.49991 10.0356 4.68406 9.76002 4.8097 9.45671C4.93534 9.15339 5 8.8283 5 8.5C5 8.327 4.97 8.163 4.937 8H4.938ZM14 9C11.25 9 9 11.25 9 14C9 16.75 11.25 19 14 19C16.75 19 19 16.75 19 14C19 11.25 16.75 9 14 9ZM14 11C15.67 11 17 12.33 17 14C17 15.67 15.67 17 14 17C12.33 17 11 15.67 11 14C11 12.33 12.33 11 14 11Z"
      fill="#417B97"
    />
  </svg>,
];

export const quickMenu = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"quickMenu"}
  >
    <path
      d="M22.7333 10.667H1.26667C0.567106 10.667 0 11.2341 0 11.9337V12.067C0 12.7666 0.567106 13.3337 1.26667 13.3337H22.7333C23.4329 13.3337 24 12.7666 24 12.067V11.9337C24 11.2341 23.4329 10.667 22.7333 10.667Z"
      fill="#417B97"
    />
    <path
      d="M22.7333 17.333H1.26667C0.567106 17.333 0 17.9001 0 18.5997V18.733C0 19.4326 0.567106 19.9997 1.26667 19.9997H22.7333C23.4329 19.9997 24 19.4326 24 18.733V18.5997C24 17.9001 23.4329 17.333 22.7333 17.333Z"
      fill="#417B97"
    />
    <path
      d="M22.7333 4H1.26667C0.567106 4 0 4.56711 0 5.26667V5.4C0 6.09956 0.567106 6.66667 1.26667 6.66667H22.7333C23.4329 6.66667 24 6.09956 24 5.4V5.26667C24 4.56711 23.4329 4 22.7333 4Z"
      fill="#417B97"
    />
  </svg>,
];

export const todoList = [
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"todoList"}
  >
    <path
      d="M9.10061 17.8913L3.26277 23.7291L0.0195312 20.4859L1.39596 19.1094L3.26277 20.9775L7.72418 16.5161L9.10061 17.8913ZM9.74926 4.26964V6.86424H24.0195V4.26964H9.74926ZM9.74926 22.4318H24.0195V19.8372H9.74926V22.4318ZM9.74926 14.648H24.0195V12.0534H9.74926V14.648ZM7.72418 8.73105L3.26277 13.1938L1.39596 11.3269L0.0195312 12.7021L3.26277 15.9453L9.10061 10.1075L7.72418 8.73105ZM7.72418 0.947266L3.26277 5.40997L1.39596 3.54186L0.0195312 4.91829L3.26277 8.16154L9.10061 2.3237L7.72418 0.947266Z"
      fill="#417B97"
    />
  </svg>,
];

export const buttomArrow = [
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"buttomArrow"}
  >
    <path
      d="M4.99919 3.17177L7.82719 0.342773L9.24219 1.75677L4.99919 5.99977L0.756187 1.75677L2.17119 0.342773L4.99919 3.17177Z"
      fill="black"
    />
  </svg>,
];

export const topArrow = [
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"topArrow"}
  >
    <path
      d="M5.00081 2.82725L2.17281 5.65625L0.757812 4.24225L5.00081 -0.000749773L9.24381 4.24225L7.82881 5.65625L5.00081 2.82725Z"
      fill="black"
    />
  </svg>,
];

export const stock = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"stock"}
  >
    <path
      d="M14.2928 0.855952C13.4609 0.535972 12.5399 0.535972 11.708 0.855952L7.55479 2.45195C7.2151 2.58247 6.92295 2.81288 6.71687 3.1128C6.51078 3.41272 6.40044 3.76805 6.40039 4.13195V5.45315C6.79882 5.40297 7.20196 5.40297 7.60039 5.45315V4.13315C7.60026 4.01188 7.63689 3.89341 7.70544 3.79337C7.77399 3.69333 7.87125 3.61641 7.98439 3.57275L12.1388 1.97555C12.6934 1.76223 13.3074 1.76223 13.862 1.97555L18.0152 3.57275C18.1283 3.61641 18.2256 3.69333 18.2941 3.79337C18.3627 3.89341 18.3993 4.01188 18.3992 4.13315V13.4692C18.3991 13.5902 18.3623 13.7084 18.2938 13.8082C18.2253 13.908 18.1281 13.9848 18.0152 14.0284L14.7992 15.2656V15.8692C14.7992 16.114 14.7704 16.354 14.7128 16.5844L18.446 15.1492C18.7857 15.0186 19.0778 14.7882 19.2839 14.4883C19.49 14.1884 19.6003 13.833 19.6004 13.4692V4.13195C19.6003 3.76805 19.49 3.41272 19.2839 3.1128C19.0778 2.81288 18.7857 2.58247 18.446 2.45195L14.2928 0.855952ZM17.3096 4.35395C17.2524 4.20552 17.1387 4.08586 16.9933 4.02127C16.8479 3.95669 16.6829 3.95248 16.5344 4.00955L13.2152 5.28635C13.0765 5.33968 12.923 5.33968 12.7844 5.28635L9.46519 4.00955C9.39122 3.97893 9.31186 3.96343 9.2318 3.96396C9.15174 3.96448 9.0726 3.98102 8.99903 4.01261C8.92547 4.04419 8.85896 4.09018 8.80344 4.14786C8.74792 4.20555 8.70451 4.27376 8.67576 4.34848C8.64701 4.4232 8.6335 4.50291 8.63604 4.58293C8.63857 4.66296 8.65709 4.74166 8.69051 4.81441C8.72394 4.88716 8.77158 4.95249 8.83064 5.00654C8.88969 5.0606 8.95897 5.10229 9.03439 5.12915L12.3536 6.40595C12.7695 6.56594 13.23 6.56594 13.646 6.40595L16.9652 5.12915C17.1136 5.07198 17.2333 4.95821 17.2979 4.81285C17.3625 4.66748 17.3667 4.50242 17.3096 4.35395ZM11.3096 10.354C11.2524 10.2055 11.1387 10.0859 10.9933 10.0213C10.8479 9.95669 10.6829 9.95248 10.5344 10.0096L7.00039 11.3692L3.46519 10.0096C3.31656 9.95243 3.15133 9.95668 3.00584 10.0214C2.86035 10.0861 2.74652 10.2059 2.68939 10.3546C2.63226 10.5032 2.63652 10.6684 2.70122 10.8139C2.76592 10.9594 2.88576 11.0732 3.03439 11.1304L6.40039 12.424V15.412C6.40039 15.5711 6.4636 15.7237 6.57613 15.8362C6.68865 15.9487 6.84126 16.012 7.00039 16.012C7.15952 16.012 7.31213 15.9487 7.42465 15.8362C7.53718 15.7237 7.60039 15.5711 7.60039 15.412V12.424L10.9652 11.1292C11.1136 11.072 11.2333 10.9582 11.2979 10.8128C11.3624 10.6675 11.3667 10.5024 11.3096 10.354ZM8.29279 6.85595C7.4609 6.53597 6.53988 6.53597 5.70799 6.85595L1.55479 8.45195C1.2151 8.58247 0.922954 8.81288 0.716868 9.1128C0.510782 9.41271 0.400439 9.76805 0.400391 10.132V15.868C0.400439 16.2319 0.510782 16.5872 0.716868 16.8871C0.922954 17.187 1.2151 17.4174 1.55479 17.548L5.70679 19.1464C6.53904 19.4666 7.46054 19.4666 8.29279 19.1464L12.446 17.5492C12.7855 17.4184 13.0773 17.1879 13.2832 16.888C13.4891 16.5881 13.5992 16.2329 13.5992 15.8692V10.1332C13.5992 9.76939 13.4891 9.41416 13.2832 9.11426C13.0773 8.81436 12.7855 8.58386 12.446 8.45315L8.29279 6.85595ZM6.13879 7.97555C6.69339 7.76223 7.3074 7.76223 7.86199 7.97555L12.0152 9.57275C12.1283 9.61641 12.2256 9.69333 12.2941 9.79337C12.3627 9.89341 12.3993 10.0119 12.3992 10.1332V15.8692C12.3991 15.9902 12.3623 16.1084 12.2938 16.2082C12.2253 16.308 12.1281 16.3848 12.0152 16.4284L7.86199 18.028C7.3074 18.2413 6.69339 18.2413 6.13879 18.028L1.98439 16.4284C1.87163 16.3848 1.77464 16.3083 1.70612 16.2087C1.6376 16.1092 1.60075 15.9912 1.60039 15.8704V10.1344C1.60026 10.0131 1.63689 9.89461 1.70544 9.79457C1.77399 9.69453 1.87125 9.61761 1.98439 9.57395L6.13879 7.97675V7.97555Z"
      fill="#A0A0A0"
    />
  </svg>,
];

export const bags = [
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"bags"}
  >
    <path
      d="M12.7508 4.625H15.3108C15.4656 4.62515 15.6149 4.68277 15.7297 4.78669C15.8444 4.89062 15.9166 5.03344 15.932 5.1875L16.3133 9H15.0558L14.7433 5.875H12.7508V7.75C12.7508 7.91576 12.6849 8.07473 12.5677 8.19194C12.4505 8.30915 12.2915 8.375 12.1258 8.375C11.96 8.375 11.8011 8.30915 11.6838 8.19194C11.5666 8.07473 11.5008 7.91576 11.5008 7.75V5.875H6.50079V7.75C6.50079 7.91576 6.43494 8.07473 6.31773 8.19194C6.20052 8.30915 6.04155 8.375 5.87579 8.375C5.71003 8.375 5.55106 8.30915 5.43385 8.19194C5.31664 8.07473 5.25079 7.91576 5.25079 7.75V5.875H3.25704L2.25704 15.875H9.00079V17.125H1.56579C1.47849 17.1249 1.39219 17.1065 1.31242 17.0711C1.23266 17.0356 1.16121 16.9838 1.10269 16.919C1.04416 16.8543 0.999849 16.778 0.972611 16.695C0.945372 16.6121 0.93581 16.5244 0.944539 16.4375L2.06954 5.1875C2.08502 5.03344 2.15714 4.89062 2.27191 4.78669C2.38669 4.68277 2.53596 4.62515 2.69079 4.625H5.25079V4.18875C5.25079 2.02125 6.92079 0.25 9.00079 0.25C11.0808 0.25 12.7508 2.02125 12.7508 4.18875V4.62625V4.625ZM11.5008 4.625V4.18875C11.5008 2.69625 10.3733 1.5 9.00079 1.5C7.62829 1.5 6.50079 2.69625 6.50079 4.18875V4.62625H11.5008V4.625ZM15.4345 13.925C15.4916 13.863 15.5605 13.8131 15.6373 13.7784C15.7141 13.7437 15.7971 13.7249 15.8813 13.7231C15.9656 13.7213 16.0493 13.7365 16.1275 13.7679C16.2057 13.7993 16.2767 13.8461 16.3363 13.9057C16.396 13.9652 16.4429 14.0362 16.4744 14.1143C16.5059 14.1925 16.5213 14.2762 16.5196 14.3604C16.5179 14.4447 16.4992 14.5277 16.4646 14.6045C16.43 14.6814 16.3802 14.7504 16.3183 14.8075L13.8183 17.3075C13.7011 17.4247 13.5421 17.4905 13.3764 17.4905C13.2107 17.4905 13.0517 17.4247 12.9345 17.3075L10.4345 14.8075C10.3748 14.7498 10.3272 14.6809 10.2945 14.6046C10.2617 14.5284 10.2445 14.4464 10.2438 14.3634C10.243 14.2804 10.2589 14.1981 10.2903 14.1213C10.3217 14.0445 10.3681 13.9747 10.4268 13.916C10.4855 13.8573 10.5553 13.8109 10.6321 13.7795C10.7089 13.7481 10.7912 13.7322 10.8742 13.733C10.9572 13.7337 11.0392 13.7509 11.1154 13.7837C11.1917 13.8164 11.2606 13.8641 11.3183 13.9237L12.7508 15.3575V10.875C12.7508 10.7092 12.8166 10.5503 12.9338 10.4331C13.0511 10.3158 13.21 10.25 13.3758 10.25C13.5415 10.25 13.7005 10.3158 13.8177 10.4331C13.9349 10.5503 14.0008 10.7092 14.0008 10.875V15.3575L15.4345 13.9237V13.925Z"
      fill="#A0A0A0"
    />
  </svg>,
];

export const hearts = [
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"heart"}
  >
    <path
      d="M13.8759 1.36C14.3699 1.35958 14.859 1.45801 15.3145 1.64951C15.77 1.84101 16.1828 2.12172 16.5286 2.4752C17.2413 3.20034 17.6408 4.17735 17.6408 5.1952C17.6408 6.21306 17.2413 7.19006 16.5286 7.9152L9.5 15.0484L2.47136 7.9152C1.75871 7.19006 1.35925 6.21306 1.35925 5.1952C1.35925 4.17735 1.75871 3.20034 2.47136 2.4752C2.81743 2.12198 3.23025 1.84141 3.68571 1.64988C4.14117 1.45835 4.63014 1.35971 5.12406 1.35971C5.61798 1.35971 6.10695 1.45835 6.56241 1.64988C7.01787 1.84141 7.43069 2.12198 7.77676 2.4752L9.5 4.2432L11.2165 2.4888C11.5613 2.13111 11.9745 1.84679 12.4315 1.65284C12.8884 1.45888 13.3797 1.35929 13.8759 1.36ZM13.8759 1.82434e-06C13.2013 -0.000571226 12.5334 0.133863 11.9113 0.395423C11.2891 0.656983 10.7254 1.0404 10.2531 1.5232L9.5 2.2848L8.74693 1.5232C8.27402 1.04127 7.71014 0.65852 7.08814 0.397251C6.46614 0.135983 5.79847 0.00142625 5.12406 0.00142625C4.44965 0.00142625 3.78198 0.135983 3.15998 0.397251C2.53798 0.65852 1.9741 1.04127 1.50119 1.5232C0.539077 2.50487 0 3.82593 0 5.202C0 6.57808 0.539077 7.89914 1.50119 8.8808L9.5 17L17.4988 8.8808C18.4609 7.89914 19 6.57808 19 5.202C19 3.82593 18.4609 2.50487 17.4988 1.5232C17.026 1.04102 16.4622 0.657999 15.8402 0.396483C15.2182 0.134968 14.5505 0.000187747 13.8759 1.82434e-06Z"
      fill="#A0A0A0"
    />
  </svg>,
];

export const comments = [
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"comment"}
  >
    <path
      d="M16.2188 0.375L0.78125 0.375L0.1875 0.96875L0.1875 11.6562L0.78125 12.25H3.75V15.2188L4.76412 15.6391L8.15206 12.25L16.2188 12.25L16.8125 11.6562V0.96875L16.2188 0.375ZM15.625 11.0625L7.90625 11.0625L7.48588 11.2359L4.9375 13.7854V11.6562L4.34375 11.0625H1.375L1.375 1.5625L15.625 1.5625V11.0625Z"
      fill="#A0A0A0"
    />
  </svg>,
];

export const category = [
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"category"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H13.5C13.6326 9 13.7598 9.05268 13.8536 9.14645C13.9473 9.24021 14 9.36739 14 9.5C14 9.63261 13.9473 9.75979 13.8536 9.85355C13.7598 9.94732 13.6326 10 13.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM4 5.5C4 5.36739 4.05268 5.24021 4.14645 5.14645C4.24021 5.05268 4.36739 5 4.5 5H13.5C13.6326 5 13.7598 5.05268 13.8536 5.14645C13.9473 5.24021 14 5.36739 14 5.5C14 5.63261 13.9473 5.75979 13.8536 5.85355C13.7598 5.94732 13.6326 6 13.5 6H4.5C4.36739 6 4.24021 5.94732 4.14645 5.85355C4.05268 5.75979 4 5.63261 4 5.5ZM4 1.5C4 1.36739 4.05268 1.24021 4.14645 1.14645C4.24021 1.05268 4.36739 1 4.5 1H13.5C13.6326 1 13.7598 1.05268 13.8536 1.14645C13.9473 1.24021 14 1.36739 14 1.5C14 1.63261 13.9473 1.75979 13.8536 1.85355C13.7598 1.94732 13.6326 2 13.5 2H4.5C4.36739 2 4.24021 1.94732 4.14645 1.85355C4.05268 1.75979 4 1.63261 4 1.5ZM1 2.5C1.26522 2.5 1.51957 2.39464 1.70711 2.20711C1.89464 2.01957 2 1.76522 2 1.5C2 1.23478 1.89464 0.98043 1.70711 0.792893C1.51957 0.605357 1.26522 0.5 1 0.5C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5C0 1.76522 0.105357 2.01957 0.292893 2.20711C0.48043 2.39464 0.734784 2.5 1 2.5ZM1 6.5C1.26522 6.5 1.51957 6.39464 1.70711 6.20711C1.89464 6.01957 2 5.76522 2 5.5C2 5.23478 1.89464 4.98043 1.70711 4.79289C1.51957 4.60536 1.26522 4.5 1 4.5C0.734784 4.5 0.48043 4.60536 0.292893 4.79289C0.105357 4.98043 0 5.23478 0 5.5C0 5.76522 0.105357 6.01957 0.292893 6.20711C0.48043 6.39464 0.734784 6.5 1 6.5ZM1 10.5C1.26522 10.5 1.51957 10.3946 1.70711 10.2071C1.89464 10.0196 2 9.76522 2 9.5C2 9.23478 1.89464 8.98043 1.70711 8.79289C1.51957 8.60536 1.26522 8.5 1 8.5C0.734784 8.5 0.48043 8.60536 0.292893 8.79289C0.105357 8.98043 0 9.23478 0 9.5C0 9.76522 0.105357 10.0196 0.292893 10.2071C0.48043 10.3946 0.734784 10.5 1 10.5Z"
      fill="black"
    />
  </svg>,
];

export const variation = [
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"variation"}
  >
    <g clipPath="url(#clip0_7355_56079)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V16C1 16.2652 1.10536 16.5196 1.29289 16.7071C1.48043 16.8946 1.73478 17 2 17H12C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V2C13 1.73478 12.8946 1.48043 12.7071 1.29289C12.5196 1.10536 12.2652 1 12 1H2ZM0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H12C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V16C14 16.5304 13.7893 17.0391 13.4142 17.4142C13.0391 17.7893 12.5304 18 12 18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V2Z"
        fill="black"
      />
      <path d="M2.5 5.5H5V8H2.5V5.5Z" stroke="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5C12 5.63261 11.9473 5.75979 11.8536 5.85355C11.7598 5.94732 11.6326 6 11.5 6H7.5C7.36739 6 7.24021 5.94732 7.14645 5.85355C7.05268 5.75979 7 5.63261 7 5.5ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7H11.5C11.6326 7 11.7598 7.05268 11.8536 7.14645C11.9473 7.24021 12 7.36739 12 7.5C12 7.63261 11.9473 7.75979 11.8536 7.85355C11.7598 7.94732 11.6326 8 11.5 8H7.5C7.36739 8 7.24021 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5ZM7 12C7 11.8674 7.05268 11.7402 7.14645 11.6464C7.24021 11.5527 7.36739 11.5 7.5 11.5H11.5C11.6326 11.5 11.7598 11.5527 11.8536 11.6464C11.9473 11.7402 12 11.8674 12 12C12 12.1326 11.9473 12.2598 11.8536 12.3536C11.7598 12.4473 11.6326 12.5 11.5 12.5H7.5C7.36739 12.5 7.24021 12.4473 7.14645 12.3536C7.05268 12.2598 7 12.1326 7 12ZM7 14C7 13.8674 7.05268 13.7402 7.14645 13.6464C7.24021 13.5527 7.36739 13.5 7.5 13.5H11.5C11.6326 13.5 11.7598 13.5527 11.8536 13.6464C11.9473 13.7402 12 13.8674 12 14C12 14.1326 11.9473 14.2598 11.8536 14.3536C11.7598 14.4473 11.6326 14.5 11.5 14.5H7.5C7.36739 14.5 7.24021 14.4473 7.14645 14.3536C7.05268 14.2598 7 14.1326 7 14ZM3 12V13.5H4.5V12H3ZM2.5 11H5C5.13261 11 5.25979 11.0527 5.35355 11.1464C5.44732 11.2402 5.5 11.3674 5.5 11.5V14C5.5 14.1326 5.44732 14.2598 5.35355 14.3536C5.25979 14.4473 5.13261 14.5 5 14.5H2.5C2.36739 14.5 2.24021 14.4473 2.14645 14.3536C2.05268 14.2598 2 14.1326 2 14V11.5C2 11.3674 2.05268 11.2402 2.14645 11.1464C2.24021 11.0527 2.36739 11 2.5 11Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_7355_56079">
        <rect width="14" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>,
];

export const attribute = [
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"attribute"}
  >
    <path
      d="M12.7273 0H1.27273C0.572727 0 0 0.6 0 1.33333V10.6667C0 11.4 0.572727 12 1.27273 12H12.7273C13.4273 12 14 11.4 14 10.6667V1.33333C14 0.6 13.4273 0 12.7273 0ZM12.7273 10.6667H1.27273V1.33333H12.7273V10.6667ZM2.54545 4.66667H8.27273V6H2.54545V4.66667ZM2.54545 2.66667H8.27273V4H2.54545V2.66667Z"
      fill="black"
    />
  </svg>,
];

export const plusCircle = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"plusCircle"}
  >
    <path
      d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 1.5C7.74566 1.5 5.58365 2.39553 3.98959 3.98959C2.39553 5.58365 1.5 7.74566 1.5 10C1.5 12.2543 2.39553 14.4163 3.98959 16.0104C5.58365 17.6045 7.74566 18.5 10 18.5C12.2543 18.5 14.4163 17.6045 16.0104 16.0104C17.6045 14.4163 18.5 12.2543 18.5 10C18.5 7.74566 17.6045 5.58365 16.0104 3.98959C14.4163 2.39553 12.2543 1.5 10 1.5ZM10 5C10.1989 5 10.3897 5.07902 10.5303 5.21967C10.671 5.36032 10.75 5.55109 10.75 5.75V9.25H14.25C14.4489 9.25 14.6397 9.32902 14.7803 9.46967C14.921 9.61032 15 9.80109 15 10C15 10.1989 14.921 10.3897 14.7803 10.5303C14.6397 10.671 14.4489 10.75 14.25 10.75H10.75V14.25C10.75 14.4489 10.671 14.6397 10.5303 14.7803C10.3897 14.921 10.1989 15 10 15C9.80109 15 9.61032 14.921 9.46967 14.7803C9.32902 14.6397 9.25 14.4489 9.25 14.25V10.75H5.75C5.55109 10.75 5.36032 10.671 5.21967 10.5303C5.07902 10.3897 5 10.1989 5 10C5 9.80109 5.07902 9.61032 5.21967 9.46967C5.36032 9.32902 5.55109 9.25 5.75 9.25H9.25V5.75C9.25 5.55109 9.32902 5.36032 9.46967 5.21967C9.61032 5.07902 9.80109 5 10 5Z"
      fill="#417B97"
    />
  </svg>,
];

export const editIconPen = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"editIconPen"}
  >
    <path
      d="M16.474 5.40783L18.592 7.52483M17.836 3.54283L12.109 9.26983C11.8131 9.56533 11.6113 9.94181 11.529 10.3518L11 12.9998L13.648 12.4698C14.058 12.3878 14.434 12.1868 14.73 11.8908L20.457 6.16383C20.6291 5.99173 20.7656 5.78742 20.8588 5.56256C20.9519 5.33771 20.9998 5.09671 20.9998 4.85333C20.9998 4.60994 20.9519 4.36895 20.8588 4.14409C20.7656 3.91923 20.6291 3.71492 20.457 3.54283C20.2849 3.37073 20.0806 3.23421 19.8557 3.14108C19.6309 3.04794 19.3899 3 19.1465 3C18.9031 3 18.6621 3.04794 18.4373 3.14108C18.2124 3.23421 18.0081 3.37073 17.836 3.54283V3.54283Z"
      stroke="#A0A0A0"
      strokeWidth="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 15V18C19 18.5304 18.7893 19.0391 18.4142 19.4142C18.0391 19.7893 17.5304 20 17 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H9"
      stroke="#A0A0A0"
      strokeWidth="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
];

export const locationIcon = [
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"locationIcon"}
  >
    <path
      d="M7 7.875C6.56735 7.875 6.14442 7.74671 5.78469 7.50634C5.42496 7.26598 5.14458 6.92433 4.97901 6.52462C4.81345 6.12491 4.77013 5.68507 4.85453 5.26074C4.93894 4.83641 5.14728 4.44663 5.45321 4.14071C5.75913 3.83478 6.14891 3.62644 6.57324 3.54203C6.99757 3.45763 7.43741 3.50095 7.83712 3.66651C8.23684 3.83208 8.57848 4.11246 8.81884 4.47219C9.05921 4.83192 9.1875 5.25485 9.1875 5.6875C9.18681 6.26745 8.95612 6.82345 8.54603 7.23353C8.13595 7.64362 7.57995 7.87431 7 7.875ZM7 4.375C6.74041 4.375 6.48665 4.45198 6.27082 4.5962C6.05498 4.74042 5.88675 4.9454 5.78741 5.18523C5.68807 5.42506 5.66208 5.68896 5.71272 5.94356C5.76336 6.19816 5.88837 6.43202 6.07192 6.61558C6.25548 6.79914 6.48935 6.92414 6.74395 6.97478C6.99855 7.02543 7.26245 6.99943 7.50227 6.90009C7.7421 6.80075 7.94709 6.63253 8.09131 6.41669C8.23553 6.20085 8.3125 5.94709 8.3125 5.6875C8.31215 5.33951 8.17376 5.00587 7.9277 4.75981C7.68163 4.51374 7.34799 4.37535 7 4.375Z"
      fill="#A0A0A0"
    />
    <path
      d="M7 13.125L3.30926 8.77231C3.25797 8.70695 3.20722 8.64118 3.15701 8.575C2.52656 7.74453 2.18598 6.73016 2.18751 5.6875C2.18751 4.41115 2.69454 3.18707 3.59705 2.28455C4.49957 1.38203 5.72365 0.875 7 0.875C8.27636 0.875 9.50044 1.38203 10.403 2.28455C11.3055 3.18707 11.8125 4.41115 11.8125 5.6875C11.814 6.72969 11.4736 7.7436 10.8434 8.57369L10.843 8.575C10.843 8.575 10.7118 8.74738 10.6921 8.77056L7 13.125ZM3.85526 8.04781C3.85613 8.04781 3.95763 8.18256 3.98082 8.21144L7 11.7723L10.0231 8.20662C10.0424 8.18256 10.1448 8.04694 10.1452 8.0465C10.6602 7.36799 10.9385 6.53933 10.9375 5.6875C10.9375 4.64321 10.5227 3.64169 9.78424 2.90327C9.04581 2.16484 8.04429 1.75 7 1.75C5.95571 1.75 4.9542 2.16484 4.21577 2.90327C3.47735 3.64169 3.06251 4.64321 3.06251 5.6875C3.06159 6.53986 3.34022 7.36899 3.85569 8.04781H3.85526Z"
      fill="#A0A0A0"
    />
  </svg>,
];

export const phoneIcon = [
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"phoneIcon"}
  >
    <circle
      cx="17.5"
      cy="17.5"
      r="17.25"
      fill="white"
      stroke="#417B97"
      strokeWidth="0.5"
    />
    <path
      d="M19.8679 20.4969L21.0929 19.2719C21.2579 19.109 21.4667 18.9974 21.6938 18.9508C21.921 18.9042 22.1568 18.9246 22.3726 19.0094L23.8656 19.6055C24.0837 19.694 24.2707 19.8451 24.403 20.0398C24.5354 20.2344 24.6072 20.4639 24.6093 20.6992V23.4336C24.6081 23.5937 24.5744 23.7519 24.5104 23.8987C24.4464 24.0455 24.3533 24.1777 24.2368 24.2876C24.1203 24.3974 23.9828 24.4826 23.8325 24.5379C23.6823 24.5932 23.5224 24.6175 23.3625 24.6094C12.9007 23.9586 10.7898 15.0992 10.3906 11.7086C10.3721 11.5421 10.389 11.3736 10.4403 11.2141C10.4915 11.0546 10.576 10.9078 10.6881 10.7833C10.8002 10.6588 10.9374 10.5594 11.0907 10.4917C11.2439 10.4241 11.4098 10.3896 11.5773 10.3906H14.2187C14.4544 10.3913 14.6845 10.4625 14.8794 10.5951C15.0744 10.7276 15.2252 10.9155 15.3125 11.1344L15.9086 12.6274C15.9962 12.8423 16.0185 13.0783 15.9728 13.3059C15.9271 13.5335 15.8154 13.7426 15.6515 13.9071L14.4265 15.1321C14.4265 15.1321 15.132 19.9063 19.8679 20.4969Z"
      fill="#417B97"
    />
  </svg>,
];

export const emailIcon = [
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"emailIcon"}
  >
    <circle
      cx="17.5"
      cy="17.5"
      r="17.25"
      fill="white"
      stroke="#417B97"
      strokeWidth="0.5"
    />
    <g clipPath="url(#clip0_7355_62278)">
      <path
        d="M26.25 17.5C26.25 21.7284 22.3322 25.1562 17.5 25.1562C16.6334 25.1574 15.7703 25.0449 14.933 24.8216C14.2942 25.1453 12.8275 25.7666 10.36 26.1713C10.1413 26.2063 9.975 25.9788 10.0614 25.7753C10.4486 24.8609 10.7986 23.6425 10.9036 22.5312C9.56375 21.1859 8.75 19.425 8.75 17.5C8.75 13.2716 12.6678 9.84375 17.5 9.84375C22.3322 9.84375 26.25 13.2716 26.25 17.5ZM14.2188 17.5C14.2188 17.2099 14.1035 16.9317 13.8984 16.7266C13.6933 16.5215 13.4151 16.4062 13.125 16.4062C12.8349 16.4062 12.5567 16.5215 12.3516 16.7266C12.1465 16.9317 12.0312 17.2099 12.0312 17.5C12.0312 17.7901 12.1465 18.0683 12.3516 18.2734C12.5567 18.4785 12.8349 18.5938 13.125 18.5938C13.4151 18.5938 13.6933 18.4785 13.8984 18.2734C14.1035 18.0683 14.2188 17.7901 14.2188 17.5ZM18.5938 17.5C18.5938 17.2099 18.4785 16.9317 18.2734 16.7266C18.0683 16.5215 17.7901 16.4062 17.5 16.4062C17.2099 16.4062 16.9317 16.5215 16.7266 16.7266C16.5215 16.9317 16.4062 17.2099 16.4062 17.5C16.4062 17.7901 16.5215 18.0683 16.7266 18.2734C16.9317 18.4785 17.2099 18.5938 17.5 18.5938C17.7901 18.5938 18.0683 18.4785 18.2734 18.2734C18.4785 18.0683 18.5938 17.7901 18.5938 17.5ZM21.875 18.5938C22.1651 18.5938 22.4433 18.4785 22.6484 18.2734C22.8535 18.0683 22.9688 17.7901 22.9688 17.5C22.9688 17.2099 22.8535 16.9317 22.6484 16.7266C22.4433 16.5215 22.1651 16.4062 21.875 16.4062C21.5849 16.4062 21.3067 16.5215 21.1016 16.7266C20.8965 16.9317 20.7812 17.2099 20.7812 17.5C20.7812 17.7901 20.8965 18.0683 21.1016 18.2734C21.3067 18.4785 21.5849 18.5938 21.875 18.5938Z"
        fill="#417B97"
      />
    </g>
    <defs>
      <clipPath id="clip0_7355_62278">
        <rect
          width="17.5"
          height="17.5"
          fill="white"
          transform="translate(8.75 8.75)"
        />
      </clipPath>
    </defs>
  </svg>,
];

export const dotdotdot = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"dotdotdot"}
  >
    <path
      d="M19.5 9.75C20.0967 9.75 20.669 9.98705 21.091 10.409C21.5129 10.831 21.75 11.4033 21.75 12C21.75 12.5967 21.5129 13.169 21.091 13.591C20.669 14.0129 20.0967 14.25 19.5 14.25C18.9033 14.25 18.331 14.0129 17.909 13.591C17.4871 13.169 17.25 12.5967 17.25 12C17.25 11.4033 17.4871 10.831 17.909 10.409C18.331 9.98705 18.9033 9.75 19.5 9.75ZM12 9.75C12.5967 9.75 13.169 9.98705 13.591 10.409C14.0129 10.831 14.25 11.4033 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12C9.75 11.4033 9.98705 10.831 10.409 10.409C10.831 9.98705 11.4033 9.75 12 9.75ZM4.5 9.75C5.09674 9.75 5.66903 9.98705 6.09099 10.409C6.51295 10.831 6.75 11.4033 6.75 12C6.75 12.5967 6.51295 13.169 6.09099 13.591C5.66903 14.0129 5.09674 14.25 4.5 14.25C3.90326 14.25 3.33097 14.0129 2.90901 13.591C2.48705 13.169 2.25 12.5967 2.25 12C2.25 11.4033 2.48705 10.831 2.90901 10.409C3.33097 9.98705 3.90326 9.75 4.5 9.75Z"
      fill="black"
    />
  </svg>,
];

export const arrowUpDown = [
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"arrowUpDown"}
  >
    <g clipPath="url(#clip0_7355_66231)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5006 15.0009C11.6332 15.0009 11.7604 14.9482 11.8542 14.8544C11.948 14.7607 12.0006 14.6335 12.0006 14.5009V2.70789L15.1466 5.85489C15.2405 5.94878 15.3679 6.00153 15.5006 6.00153C15.6334 6.00153 15.7607 5.94878 15.8546 5.85489C15.9485 5.76101 16.0013 5.63367 16.0013 5.50089C16.0013 5.36812 15.9485 5.24078 15.8546 5.14689L11.8546 1.14689C11.8082 1.10033 11.753 1.06339 11.6923 1.03818C11.6315 1.01297 11.5664 1 11.5006 1C11.4349 1 11.3697 1.01297 11.309 1.03818C11.2483 1.06339 11.1931 1.10033 11.1466 1.14689L7.14663 5.14689C7.05274 5.24078 7 5.36812 7 5.50089C7 5.63367 7.05274 5.76101 7.14663 5.85489C7.24052 5.94878 7.36786 6.00153 7.50063 6.00153C7.63341 6.00153 7.76075 5.94878 7.85463 5.85489L11.0006 2.70789V14.5009C11.0006 14.6335 11.0533 14.7607 11.1471 14.8544C11.2408 14.9482 11.368 15.0009 11.5006 15.0009ZM4.50063 1.00089C4.63324 1.00089 4.76042 1.05357 4.85419 1.14734C4.94795 1.24111 5.00063 1.36829 5.00063 1.50089V13.2939L8.14663 10.1469C8.24052 10.053 8.36786 10.0003 8.50063 10.0003C8.63341 10.0003 8.76075 10.053 8.85463 10.1469C8.94852 10.2408 9.00126 10.3681 9.00126 10.5009C9.00126 10.6337 8.94852 10.761 8.85463 10.8549L4.85463 14.8549C4.80819 14.9015 4.75301 14.9384 4.69227 14.9636C4.63152 14.9888 4.5664 15.0018 4.50063 15.0018C4.43486 15.0018 4.36974 14.9888 4.309 14.9636C4.24825 14.9384 4.19308 14.9015 4.14663 14.8549L0.146632 10.8549C0.052745 10.761 -3.1283e-09 10.6337 0 10.5009C3.1283e-09 10.3681 0.052745 10.2408 0.146632 10.1469C0.240518 10.053 0.367856 10.0003 0.500632 10.0003C0.633407 10.0003 0.760745 10.053 0.854632 10.1469L4.00063 13.2939V1.50089C4.00063 1.36829 4.05331 1.24111 4.14708 1.14734C4.24085 1.05357 4.36802 1.00089 4.50063 1.00089Z"
        fill="#A0A0A0"
      />
    </g>
    <defs>
      <clipPath id="clip0_7355_66231">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
];

export const cartOrder = [
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"cartOrder"}
  >
    <path
      d="M8.57366 24.0008C9.52043 24.0008 10.2879 23.2333 10.2879 22.2866C10.2879 21.3398 9.52043 20.5723 8.57366 20.5723C7.62689 20.5723 6.85938 21.3398 6.85938 22.2866C6.85938 23.2333 7.62689 24.0008 8.57366 24.0008Z"
      fill="#417B97"
    />
    <path
      d="M20.5737 24.0008C21.5204 24.0008 22.2879 23.2333 22.2879 22.2866C22.2879 21.3398 21.5204 20.5723 20.5737 20.5723C19.6269 20.5723 18.8594 21.3398 18.8594 22.2866C18.8594 23.2333 19.6269 24.0008 20.5737 24.0008Z"
      fill="#417B97"
    />
    <path
      d="M24 4.28589H4.98857L4.28571 0.685889C4.24564 0.489367 4.13792 0.31312 3.98131 0.187827C3.82469 0.0625342 3.6291 -0.00386956 3.42857 0.000174376H0V1.71446H2.72571L6 18.1716C6.04007 18.3681 6.14779 18.5444 6.30441 18.6697C6.46102 18.795 6.65662 18.8614 6.85714 18.8573H22.2857V17.143H7.56L6.85714 13.7145H22.2857C22.4839 13.7193 22.6775 13.6553 22.8338 13.5334C22.9901 13.4115 23.0993 13.2392 23.1429 13.0459L24.8571 5.3316C24.8859 5.20442 24.8852 5.07237 24.8552 4.94549C24.8252 4.81861 24.7666 4.70024 24.684 4.59941C24.6013 4.49857 24.4967 4.41792 24.3782 4.36359C24.2597 4.30926 24.1303 4.28269 24 4.28589ZM21.6 12.0002H6.53143L5.33143 6.00017H22.9286L21.6 12.0002Z"
      fill="#417B97"
    />
  </svg>,
];

export const walletIncom = [
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"walletIncom"}
  >
    <path
      d="M28.8016 10.8H6.30156V9.89998L26.1016 8.31598V9.89998H28.8016V7.19998C28.8016 5.21998 27.1978 3.83038 25.2394 4.10938L7.16556 6.69058C5.20536 6.97138 3.60156 8.81998 3.60156 10.8V28.8C3.60156 29.7548 3.98085 30.6704 4.65598 31.3456C5.33111 32.0207 6.24678 32.4 7.20156 32.4H28.8016C29.7563 32.4 30.672 32.0207 31.3471 31.3456C32.0223 30.6704 32.4016 29.7548 32.4016 28.8V14.4C32.4016 13.4452 32.0223 12.5295 31.3471 11.8544C30.672 11.1793 29.7563 10.8 28.8016 10.8V10.8ZM26.1016 23.4108C25.7469 23.4107 25.3957 23.3407 25.068 23.2048C24.7404 23.069 24.4427 22.87 24.192 22.6191C23.9413 22.3682 23.7424 22.0704 23.6068 21.7426C23.4712 21.4149 23.4014 21.0637 23.4016 20.709C23.4017 20.3543 23.4717 20.0031 23.6075 19.6755C23.7433 19.3478 23.9424 19.0501 24.1933 18.7994C24.4442 18.5487 24.742 18.3498 25.0697 18.2142C25.3974 18.0786 25.7487 18.0089 26.1034 18.009C26.8197 18.0092 27.5066 18.294 28.0129 18.8007C28.5193 19.3074 28.8036 19.9945 28.8034 20.7108C28.8031 21.4271 28.5183 22.114 28.0116 22.6203C27.505 23.1267 26.8179 23.411 26.1016 23.4108Z"
      fill="white"
    />
  </svg>,
];

export const menuCampaign = [
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"menuCampaign"}
  >
    <path
      d="M19.684 11.5141V13.7427H24.1412V11.5141H19.684ZM17.4555 18.8795C18.5252 19.6707 19.918 20.7181 21.0212 21.5427C21.4669 20.9521 21.9126 20.3504 22.3583 19.7598C21.2552 18.9353 19.8623 17.8878 18.7926 17.0855C18.3469 17.6873 17.9012 18.289 17.4555 18.8795ZM22.3583 5.49697C21.9126 4.9064 21.4669 4.30468 21.0212 3.71411C19.918 4.53868 18.5252 5.58611 17.4555 6.3884C17.9012 6.97897 18.3469 7.58068 18.7926 8.17125C19.8623 7.36897 21.2552 6.33268 22.3583 5.49697ZM4.08404 9.28554C2.85833 9.28554 1.85547 10.2884 1.85547 11.5141V13.7427C1.85547 14.9684 2.85833 15.9713 4.08404 15.9713H5.19833V20.4284H7.4269V15.9713H8.54118L14.1126 19.3141V5.94268L8.54118 9.28554H4.08404ZM9.6889 11.191L11.884 9.87611V15.3807L9.6889 14.0658L9.15404 13.7427H4.08404V11.5141H9.15404L9.6889 11.191ZM16.8983 12.6284C16.8983 11.1464 16.252 9.80925 15.2269 8.89554V16.3501C16.252 15.4475 16.8983 14.1104 16.8983 12.6284Z"
      fill="#417B97"
    />
  </svg>,
];

export const menuProduct = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"menuProduct"}
  >
    <path
      d="M19.9263 9.29453H4.64775V19.9895H19.9263V9.29453ZM2.35598 7.76668H22.218V3.18312H2.35598V7.76668ZM21.4541 9.29453V20.7534C21.4541 20.956 21.3736 21.1503 21.2304 21.2936C21.0871 21.4369 20.8928 21.5173 20.6902 21.5173H3.88383C3.68122 21.5173 3.48691 21.4369 3.34365 21.2936C3.20039 21.1503 3.1199 20.956 3.1199 20.7534V9.29453H1.59205C1.38945 9.29453 1.19514 9.21405 1.05187 9.07078C0.90861 8.92752 0.828125 8.73321 0.828125 8.5306V2.4192C0.828125 2.21659 0.90861 2.02229 1.05187 1.87902C1.19514 1.73576 1.38945 1.65527 1.59205 1.65527H22.982C23.1846 1.65527 23.3789 1.73576 23.5221 1.87902C23.6654 2.02229 23.7459 2.21659 23.7459 2.4192V8.5306C23.7459 8.73321 23.6654 8.92752 23.5221 9.07078C23.3789 9.21405 23.1846 9.29453 22.982 9.29453H21.4541ZM9.99523 12.3502H14.5788C14.7814 12.3502 14.9757 12.4307 15.119 12.574C15.2622 12.7172 15.3427 12.9116 15.3427 13.1142C15.3427 13.3168 15.2622 13.5111 15.119 13.6543C14.9757 13.7976 14.7814 13.8781 14.5788 13.8781H9.99523C9.79263 13.8781 9.59832 13.7976 9.45506 13.6543C9.31179 13.5111 9.23131 13.3168 9.23131 13.1142C9.23131 12.9116 9.31179 12.7172 9.45506 12.574C9.59832 12.4307 9.79263 12.3502 9.99523 12.3502Z"
      fill="#417B97"
    />
  </svg>,
];

export const menuReport = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"menuReport"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 21H22.5V19.5H3V0H1.5V20.25L2.25 21ZM4.5 17.25V5.25L5.25 4.5H8.25L9 5.25V17.25L8.25 18H5.25L4.5 17.25ZM7.5 16.5V6H6V16.5H7.5ZM16.5 2.25V17.25L17.25 18H20.25L21 17.25V2.25L20.25 1.5H17.25L16.5 2.25ZM19.5 3V16.5H18V3H19.5ZM10.5 17.25V8.25L11.25 7.5H14.25L15 8.25V17.25L14.25 18H11.25L10.5 17.25ZM13.5 16.5V9H12V16.5H13.5Z"
      fill="#417B97"
    />
  </svg>,
];

export const menuPeple = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"menuPeple"}
  >
    <path
      d="M22.5 21C22.5 21 24 21 24 19.5C24 18 22.5 13.5 16.5 13.5C10.5 13.5 9 18 9 19.5C9 21 10.5 21 10.5 21H22.5ZM10.533 19.5C10.5219 19.4985 10.5109 19.4965 10.5 19.494C10.5015 19.098 10.7505 17.949 11.64 16.914C12.468 15.9435 13.923 15 16.5 15C19.0755 15 20.5305 15.945 21.36 16.914C22.2495 17.949 22.497 19.0995 22.5 19.494L22.488 19.497C22.481 19.4982 22.474 19.4992 22.467 19.5H10.533V19.5ZM16.5 10.5C17.2956 10.5 18.0587 10.1839 18.6213 9.62132C19.1839 9.05871 19.5 8.29565 19.5 7.5C19.5 6.70435 19.1839 5.94129 18.6213 5.37868C18.0587 4.81607 17.2956 4.5 16.5 4.5C15.7044 4.5 14.9413 4.81607 14.3787 5.37868C13.8161 5.94129 13.5 6.70435 13.5 7.5C13.5 8.29565 13.8161 9.05871 14.3787 9.62132C14.9413 10.1839 15.7044 10.5 16.5 10.5ZM21 7.5C21 8.09095 20.8836 8.67611 20.6575 9.22208C20.4313 9.76804 20.0998 10.2641 19.682 10.682C19.2641 11.0998 18.768 11.4313 18.2221 11.6575C17.6761 11.8836 17.0909 12 16.5 12C15.9091 12 15.3239 11.8836 14.7779 11.6575C14.232 11.4313 13.7359 11.0998 13.318 10.682C12.9002 10.2641 12.5687 9.76804 12.3425 9.22208C12.1164 8.67611 12 8.09095 12 7.5C12 6.30653 12.4741 5.16193 13.318 4.31802C14.1619 3.47411 15.3065 3 16.5 3C17.6935 3 18.8381 3.47411 19.682 4.31802C20.5259 5.16193 21 6.30653 21 7.5V7.5ZM10.404 13.92C9.80397 13.7311 9.18545 13.6069 8.559 13.5495C8.207 13.516 7.85359 13.4995 7.5 13.5C1.5 13.5 0 18 0 19.5C0 20.5005 0.4995 21 1.5 21H7.824C7.60163 20.5317 7.49074 20.0183 7.5 19.5C7.5 17.985 8.0655 16.437 9.135 15.144C9.4995 14.703 9.924 14.2905 10.404 13.92ZM7.38 15C6.49223 16.3339 6.01266 17.8977 6 19.5H1.5C1.5 19.11 1.746 17.955 2.64 16.914C3.4575 15.96 4.878 15.03 7.38 15.0015V15ZM2.25 8.25C2.25 7.05653 2.72411 5.91193 3.56802 5.06802C4.41193 4.22411 5.55653 3.75 6.75 3.75C7.94347 3.75 9.08807 4.22411 9.93198 5.06802C10.7759 5.91193 11.25 7.05653 11.25 8.25C11.25 9.44347 10.7759 10.5881 9.93198 11.432C9.08807 12.2759 7.94347 12.75 6.75 12.75C5.55653 12.75 4.41193 12.2759 3.56802 11.432C2.72411 10.5881 2.25 9.44347 2.25 8.25V8.25ZM6.75 5.25C5.95435 5.25 5.19129 5.56607 4.62868 6.12868C4.06607 6.69129 3.75 7.45435 3.75 8.25C3.75 9.04565 4.06607 9.80871 4.62868 10.3713C5.19129 10.9339 5.95435 11.25 6.75 11.25C7.54565 11.25 8.30871 10.9339 8.87132 10.3713C9.43393 9.80871 9.75 9.04565 9.75 8.25C9.75 7.45435 9.43393 6.69129 8.87132 6.12868C8.30871 5.56607 7.54565 5.25 6.75 5.25Z"
      fill="#417B97"
    />
  </svg>,
];

export const memuHistory = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"memuHistory"}
  >
    <path
      d="M12.5654 6.39844H11.438C11.3349 6.39844 11.2505 6.48282 11.2505 6.58594V13.0383C11.2505 13.0992 11.2786 13.1555 11.3279 13.1906L15.2021 16.0195C15.2865 16.0805 15.4036 16.0641 15.4646 15.9797L16.1349 15.0656C16.1982 14.9789 16.1794 14.8617 16.0951 14.8031L12.7529 12.3867V6.58594C12.7529 6.48282 12.6685 6.39844 12.5654 6.39844ZM17.7169 8.16094L21.3919 9.0586C21.5091 9.08672 21.624 8.99766 21.624 8.87813L21.6427 5.09297C21.6427 4.93594 21.4622 4.84688 21.3404 4.94532L17.6466 7.83047C17.6187 7.85207 17.5974 7.8811 17.5853 7.91424C17.5731 7.94738 17.5706 7.98327 17.5779 8.0178C17.5853 8.05232 17.6022 8.08407 17.6268 8.10939C17.6514 8.13471 17.6826 8.15258 17.7169 8.16094ZM21.6474 15.218L20.3185 14.7609C20.2722 14.7451 20.2214 14.7479 20.1772 14.769C20.133 14.79 20.0987 14.8275 20.0818 14.8734C20.0372 14.993 19.9904 15.1102 19.9411 15.2273C19.524 16.2141 18.9263 17.1023 18.1622 17.8641C17.4067 18.622 16.5112 19.2261 15.5255 19.643C14.5044 20.0747 13.4068 20.2963 12.2982 20.2945C11.1779 20.2945 10.0927 20.0766 9.07083 19.643C8.08514 19.2261 7.18969 18.622 6.43411 17.8641C5.6724 17.1023 5.07474 16.2141 4.65521 15.2273C4.22587 14.2057 4.00591 13.1082 4.00833 12C4.00833 10.8797 4.2263 9.79219 4.6599 8.77032C5.07708 7.7836 5.67474 6.89532 6.4388 6.1336C7.19438 5.37567 8.08983 4.77154 9.07552 4.35469C10.0927 3.9211 11.1802 3.70313 12.3005 3.70313C13.4208 3.70313 14.506 3.9211 15.5279 4.35469C16.5136 4.77154 17.409 5.37567 18.1646 6.1336C18.4036 6.375 18.6286 6.62578 18.8349 6.89063L20.2365 5.79375C18.3919 3.43594 15.5208 1.91953 12.2958 1.92188C6.68021 1.92422 2.17083 6.48516 2.22708 12.1031C2.28333 17.6227 6.77161 22.0781 12.3005 22.0781C16.6482 22.0781 20.3513 19.3219 21.7622 15.4617C21.7974 15.3633 21.7458 15.2531 21.6474 15.218Z"
      fill="#417B97"
    />
  </svg>,
];

export const memuSetting = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"memuSetting"}
  >
    <path
      d="M12 12C13.3261 12 14.5979 11.4732 15.5355 10.5355C16.4732 9.59785 17 8.32608 17 7C17 5.67392 16.4732 4.40215 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7C7 8.32608 7.52678 9.59785 8.46447 10.5355C9.40215 11.4732 10.6739 12 12 12ZM15.3333 7C15.3333 7.88405 14.9821 8.7319 14.357 9.35702C13.7319 9.98214 12.8841 10.3333 12 10.3333C11.1159 10.3333 10.2681 9.98214 9.64298 9.35702C9.01786 8.7319 8.66667 7.88405 8.66667 7C8.66667 6.11594 9.01786 5.2681 9.64298 4.64298C10.2681 4.01786 11.1159 3.66667 12 3.66667C12.8841 3.66667 13.7319 4.01786 14.357 4.64298C14.9821 5.2681 15.3333 6.11594 15.3333 7ZM22 20.3333C22 22 20.3333 22 20.3333 22H3.66667C3.66667 22 2 22 2 20.3333C2 18.6667 3.66667 13.6667 12 13.6667C20.3333 13.6667 22 18.6667 22 20.3333ZM20.3333 20.3267C20.3317 19.9167 20.0767 18.6833 18.9467 17.5533C17.86 16.4667 15.815 15.3333 12 15.3333C8.18333 15.3333 6.14 16.4667 5.05333 17.5533C3.92333 18.6833 3.67 19.9167 3.66667 20.3267H20.3333Z"
      fill="#417B97"
    />
  </svg>,
];

export const memuHelp = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"memuHelp"}
  >
    <path
      d="M12 22.0009C6.48 21.9949 2.006 17.5209 2 12.0009V11.8009C2.11 6.30588 6.635 1.92888 12.13 2.00088C17.627 2.07488 22.034 6.56988 21.998 12.0659C21.962 17.5629 17.497 22.0009 12 22.0009ZM11.984 20.0009H12C14.121 19.9988 16.1544 19.1544 17.6531 17.6535C19.1518 16.1526 19.9931 14.1179 19.992 11.9969C19.9909 9.87584 19.1476 7.84204 17.6474 6.34261C16.1473 4.84319 14.113 4.00088 11.992 4.00088C9.87096 4.00088 7.83674 4.84319 6.33656 6.34261C4.83638 7.84204 3.99306 9.87584 3.992 11.9969C3.99094 14.1179 4.83223 16.1526 6.3309 17.6535C7.82958 19.1544 9.86296 19.9988 11.984 20.0009ZM13 18.0009H11V16.0009H13V18.0009ZM13 15.0009H11C10.9845 14.3614 11.1404 13.7294 11.4517 13.1705C11.763 12.6117 12.2181 12.1464 12.77 11.8229C13.43 11.3169 14 10.8809 14 10.0009C14 9.47044 13.7893 8.96174 13.4142 8.58666C13.0391 8.21159 12.5304 8.00088 12 8.00088C11.4696 8.00088 10.9609 8.21159 10.5858 8.58666C10.2107 8.96174 10 9.47044 10 10.0009H8V9.91088C8.01193 8.85001 8.44481 7.83734 9.20339 7.09563C9.96198 6.35392 10.9841 5.94394 12.045 5.95588C13.1059 5.96781 14.1185 6.40068 14.8602 7.15927C15.602 7.91785 16.0119 8.94001 16 10.0009C15.9647 10.533 15.8052 11.0494 15.5343 11.5087C15.2634 11.9681 14.8886 12.3575 14.44 12.6459C14.0344 12.9005 13.6933 13.2457 13.4434 13.6543C13.1936 14.0628 13.0418 14.5238 13 15.0009Z"
      fill="#417B97"
    />
  </svg>,
];

export const memuContact = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"memuContact"}
  >
    <path
      d="M21 8.00088C21.5304 8.00088 22.0391 8.21159 22.4142 8.58666C22.7893 8.96174 23 9.47044 23 10.0009V14.0009C23 14.5313 22.7893 15.04 22.4142 15.4151C22.0391 15.7902 21.5304 16.0009 21 16.0009H19.938C19.6942 17.9342 18.7533 19.7121 17.2917 21.0009C15.8302 22.2897 13.9486 23.0008 12 23.0009V21.0009C13.5913 21.0009 15.1174 20.3687 16.2426 19.2435C17.3679 18.1183 18 16.5922 18 15.0009V9.00088C18 7.40958 17.3679 5.88345 16.2426 4.75824C15.1174 3.63302 13.5913 3.00088 12 3.00088C10.4087 3.00088 8.88258 3.63302 7.75736 4.75824C6.63214 5.88345 6 7.40958 6 9.00088V16.0009H3C2.46957 16.0009 1.96086 15.7902 1.58579 15.4151C1.21071 15.04 1 14.5313 1 14.0009V10.0009C1 9.47044 1.21071 8.96174 1.58579 8.58666C1.96086 8.21159 2.46957 8.00088 3 8.00088H4.062C4.30603 6.06777 5.24708 4.29015 6.70857 3.00155C8.17007 1.71296 10.0516 1.00195 12 1.00195C13.9484 1.00195 15.8299 1.71296 17.2914 3.00155C18.7529 4.29015 19.694 6.06777 19.938 8.00088H21ZM7.76 15.7859L8.82 14.0899C9.77308 14.6869 10.8754 15.0027 12 15.0009C13.1246 15.0027 14.2269 14.6869 15.18 14.0899L16.24 15.7859C14.9693 16.582 13.4995 17.0032 12 17.0009C10.5005 17.0032 9.03074 16.582 7.76 15.7859Z"
      fill="#417B97"
    />
  </svg>,
];

export const facebook = [
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"facebook"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12.067C0 18.033 4.333 22.994 10 24V15.333H7V12H10V9.333C10 6.333 11.933 4.667 14.667 4.667C15.533 4.667 16.467 4.8 17.333 4.933V8H15.8C14.333 8 14 8.733 14 9.667V12H17.2L16.667 15.333H14V24C19.667 22.994 24 18.034 24 12.067C24 5.43 18.6 0 12 0C5.4 0 0 5.43 0 12.067Z"
      fill="#417B97"
    />
  </svg>,
];

export const email = [
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"email"}
  >
    <path
      d="M20.4286 0H1.57143C1.15466 0 0.754961 0.168571 0.460261 0.468629C0.165561 0.768687 0 1.17565 0 1.6V14.4C0 14.8243 0.165561 15.2313 0.460261 15.5314C0.754961 15.8314 1.15466 16 1.57143 16H20.4286C20.8453 16 21.245 15.8314 21.5397 15.5314C21.8344 15.2313 22 14.8243 22 14.4V1.6C22 1.17565 21.8344 0.768687 21.5397 0.468629C21.245 0.168571 20.8453 0 20.4286 0ZM18.7 1.6L11 7.024L3.3 1.6H18.7ZM1.57143 14.4V2.328L10.5521 8.656C10.6837 8.7489 10.8399 8.79869 11 8.79869C11.1601 8.79869 11.3163 8.7489 11.4479 8.656L20.4286 2.328V14.4H1.57143Z"
      fill="#417B97"
    />
  </svg>,
];

export const call = [
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"call"}
  >
    <path
      d="M9.55423 5.24101L6.17123 1.33601C5.78123 0.886007 5.06623 0.888007 4.61323 1.34201L1.83123 4.12901C1.00323 4.95801 0.766232 6.18901 1.24523 7.17601C4.10685 13.101 8.88528 17.8861 14.8062 20.756C15.7922 21.235 17.0222 20.998 17.8502 20.169L20.6582 17.356C21.1132 16.901 21.1142 16.182 20.6602 15.792L16.7402 12.427C16.3302 12.075 15.6932 12.121 15.2822 12.533L13.9182 13.899C13.8484 13.9722 13.7565 14.0204 13.6566 14.0363C13.5567 14.0522 13.4543 14.0349 13.3652 13.987C11.1357 12.7031 9.28622 10.8512 8.00523 8.62001C7.95726 8.53076 7.93989 8.42823 7.95578 8.32816C7.97168 8.22809 8.01996 8.136 8.09323 8.06601L9.45323 6.70501C9.86523 6.29101 9.91023 5.65201 9.55423 5.24101Z"
      stroke="#417B97"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
];

export const locationCircle = [
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={"locationCircle"}
  >
    <circle
      cx="17.5"
      cy="17.5"
      r="17.25"
      fill="white"
      stroke="#417B97"
      stroke-width="0.5"
    />
    <path
      d="M17.5 9.84375C15.9051 9.84563 14.3761 10.48 13.2484 11.6078C12.1207 12.7355 11.4863 14.2645 11.4844 15.8594C11.4825 17.1627 11.9082 18.4307 12.6963 19.4688C12.6963 19.4688 12.8603 19.6848 12.8871 19.7159L17.5 25.1562L22.1151 19.7132C22.1391 19.6842 22.3038 19.4688 22.3038 19.4688L22.3043 19.4671C23.092 18.4295 23.5175 17.1621 23.5156 15.8594C23.5138 14.2645 22.8794 12.7355 21.7516 11.6078C20.6239 10.48 19.0949 9.84563 17.5 9.84375ZM17.5 18.0469C17.0674 18.0469 16.6444 17.9186 16.2847 17.6782C15.925 17.4378 15.6446 17.0962 15.479 16.6965C15.3135 16.2968 15.2701 15.8569 15.3545 15.4326C15.4389 15.0083 15.6473 14.6185 15.9532 14.3126C16.2591 14.0067 16.6489 13.7983 17.0732 13.7139C17.4976 13.6295 17.9374 13.6728 18.3371 13.8384C18.7368 14.004 19.0785 14.2843 19.3188 14.6441C19.5592 15.0038 19.6875 15.4267 19.6875 15.8594C19.6868 16.4393 19.4561 16.9953 19.046 17.4054C18.6359 17.8155 18.0799 18.0462 17.5 18.0469Z"
      fill="#417B97"
    />
  </svg>,
];

export const userAgent = [
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.4C9.16 2.4 10.1 3.34 10.1 4.5C10.1 5.66 9.16 6.6 8 6.6C6.84 6.6 5.9 5.66 5.9 4.5C5.9 3.34 6.84 2.4 8 2.4ZM8 11.4C10.97 11.4 14.1 12.86 14.1 13.5V14.6H1.9V13.5C1.9 12.86 5.03 11.4 8 11.4ZM8 0.5C5.79 0.5 4 2.29 4 4.5C4 6.71 5.79 8.5 8 8.5C10.21 8.5 12 6.71 12 4.5C12 2.29 10.21 0.5 8 0.5ZM8 9.5C5.33 9.5 0 10.84 0 13.5V16.5H16V13.5C16 10.84 10.67 9.5 8 9.5Z"
      fill="#666CFF"
    />
  </svg>,
];

export const graphDashboard = [
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66602 9.7H8.66602V19.5H5.66602V9.7ZM11.266 5.5H14.066V19.5H11.266V5.5ZM16.866 13.5H19.666V19.5H16.866V13.5Z"
      fill="#FDB528"
    />
  </svg>,
];

export const graphDashboard2 = [
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.334 6.5L18.624 8.79L13.744 13.67L9.74398 9.67L2.33398 17.09L3.74398 18.5L9.74398 12.5L13.744 16.5L20.044 10.21L22.334 12.5V6.5H16.334Z"
      fill="#26C6F9"
    />
  </svg>,
];

export const hospital = [
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 5.25H15.75V11.25V20.25H14.25V13.5H9.75V20.25H8.25V14.25V5.25ZM11.25 20.25H12.75V15H11.25V20.25ZM15.75 21.75H8.25H6.75H2.25V14.25H6.75V3.75H17.25V11.25H21.75V21.75H17.25H15.75ZM6.75 15.75V20.25H3.75V15.75H6.75ZM17.25 20.25H20.25V12.75H17.25V20.25ZM11.25 7.5V8.25H10.5V9.75H11.25V10.5H12.75V9.75H13.5V8.25H12.75V7.5H11.25Z"
      fill="#417B97" />
  </svg>
]

export const userSystem = [
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.5" d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914C3 11.4234 3 10.8996 3 10.4167Z" stroke="#417B97" stroke-width="1.5" />
    <circle cx="12" cy="9" r="2" stroke="#417B97" stroke-width="1.5" 
    fill="#417B97"
    />
    <path d="M16 15C16 16.1046 16 17 12 17C8 17 8 16.1046 8 15C8 13.8954 9.79086 13 12 13C14.2091 13 16 13.8954 16 15Z" stroke="#417B97" stroke-width="1.5" />
  </svg>
]
